import { createAction, props } from "@ngrx/store";

const createConnection = createAction(
  "[Connection] Create Connection",
  props<{ id: any; connection: {} }>()
);

const createConnectionSuccess = createAction(
  "[Connection] Create Connection Success",
  props<{ connection: any }>()
);

const createConnectionFailure = createAction(
  "[Connection] Create Connection Failure",
  props<{ error: any }>()
);

const getConnections = createAction(
  "[Connection] get Connection",
  props<{ id: any }>()
);

const getConnectionSuccess = createAction(
  "[Connection] get Connection Success",
  props<{ connection: any }>()
);

const getConnectionFailure = createAction(
  "[Connection] get Connection Failure",
  props<{ error: any }>()
);

const updateConnection = createAction(
  "[Connection] update Connection",
  props<{ projectId: string; connId: string; connection: {} }>()
);

const updateConnectionSuccess = createAction(
  "[Connection] update Connection Success",
  props<{ connection: any }>()
);

const updateConnectionFailure = createAction(
  "[Connection] update Connection Failure",
  props<{ error: any }>()
);

const deleteConnection = createAction(
  "[Connection] delete Connection",
  props<{ projectId: string; connId: string; }>()
);

const deleteConnectionSuccess = createAction(
  "[Connection] delete Connection Success",
  props<{ connection: any }>()
);

const deleteConnectionFailure = createAction(
  "[Connection] delete Connection Failure",
  props<{ error: any }>()
);

const createFileConnection = createAction(
  "[Connection] Create File Connection",
  props<{ id: any; connection: {} }>()
);

const createFileConnectionSuccess = createAction(
  "[Connection] Create File Connection Success",
  props<{ connection: any }>()
);

const createFileConnectionFailure = createAction(
  "[Connection] Create File Connection Failure",
  props<{ error: any }>()
);

export const ConnectionActions = {
  createConnection,
  createConnectionSuccess,
  createConnectionFailure,
  getConnections,
  getConnectionSuccess,
  getConnectionFailure,
  updateConnection,
  updateConnectionSuccess,
  updateConnectionFailure,
  deleteConnection,
  deleteConnectionSuccess,
  deleteConnectionFailure,
  createFileConnection,
  createFileConnectionSuccess,
  createFileConnectionFailure,
};
